module.exports = __webpack_public_path__ + "static/media/newspaper.bf99b912.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newspaper.svg
// module id = 90
// module chunks = 0